var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inset-32 content" },
    [
      _c("p", { staticClass: "fs7 insety-8" }, [
        _vm._v(_vm._s(_vm.$t("fut_cust_concent_para_1"))),
      ]),
      _c("p", { staticClass: "fs7 insety-8" }, [
        _vm._v(_vm._s(_vm.$t("fut_cust_concent_para_2"))),
      ]),
      _c(
        "ib-table-basic",
        {
          ref: "table",
          staticClass: "ib-row shrink fs7 fg70 event-border",
          attrs: {
            data: _vm.Cust50PercentNetLiqList,
            height: "400px",
            spacing: "huge",
            wrap: "",
            rowstripe: "",
            rowborder: "",
            colborder: "",
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function (row) {
                return [
                  _c("td", [_c("span", [_vm._v(_vm._s(row.date))])]),
                  _c("td", [
                    row.num_customers_domestic_req != ""
                      ? _c("span", [
                          _vm._v(_vm._s(row.num_customers_domestic_req)),
                        ])
                      : _c("span", [_vm._v(_vm._s(_vm.$t("n_a")))]),
                  ]),
                  _c("td", [
                    row.num_customers_foreign_req != ""
                      ? _c("span", [
                          _vm._v(_vm._s(row.num_customers_foreign_req)),
                        ])
                      : _c("span", [_vm._v(_vm._s(_vm.$t("n_a")))]),
                  ]),
                  _c("td", [
                    row.num_customers_swap_req != ""
                      ? _c("span", [_vm._v(_vm._s(row.num_customers_swap_req))])
                      : _c("span", [_vm._v(_vm._s(_vm.$t("n_a")))]),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "15ch" } },
            [_vm._v(_vm._s(_vm.$t("date")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "15ch" } },
            [_vm._v(_vm._s(_vm.$t("domestic_Seg")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "15ch" } },
            [_vm._v(_vm._s(_vm.$t("foreign_sec")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "15ch" } },
            [_vm._v(_vm._s(_vm.$t("cleared_swaps")))]
          ),
          _c(
            "p",
            {
              staticClass: "fs7 message-align",
              attrs: { slot: "caption" },
              slot: "caption",
            },
            [_vm._v(_vm._s(_vm.$t("fut_cust_concent_table_msg")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }